<!--   
@edited libaiqi
@date 2018/11/13
------------- 
@author xiehan
@date 2018/10/11
@version v1.1.0
@description select组件拓展


Attributes:
-------------------------------------------------
value 选中的值，必须
使用 v-model
没有值时传 空字符串或者null
-------------------------------------------------
:list 接收绑定的列表，必须
:list="select_obj"
data () {
  return {
    select_obj: { objKey: 'objValue' }
  }
}
-------------------------------------------------
:defaultAll 是否显示所有
-------------------------------------------------
:defaultAllValue 显示所有对应的值，默认''（空字符串）
defaultAllValue=""
-------------------------------------------------
:tdisabled 只读，默认为false
-------------------------------------------------

Methods:
-------------------------------------------------
@change 输出下拉框所选的键值对：
@change="selectChange"
methods: {
  selectChange (val) {
    console.log(val) // { key: 'objKey', value: 'objValue'}
  }
}
-------------------------------------------------
-->
<template>
  <el-select v-model="selectValue" @change="selectChange" :disabled="tdisabled">
    <el-option key="" :label="$t('common.all')" :value="defaultAllValue" v-if="defaultAll"></el-option>
    <el-option 
      v-for="(item, index) in list" 
      :key="index" 
      :label="item"
      :value="index">
    </el-option>
  </el-select>
</template>

<script>
  export default {
    name: 'gSelect',
    data () {
      return {
        selectValue: ''
      }
    },
    props: {
      list: {
        type: [Object, Array],
        require: true
      },
      defaultAll: {
        type: Boolean,
        default: false
      },
      defaultAllValue: {
        type: [String, Number],
        default: ''
      },
      value: {
        type: [String, Number],
        require: true
      },
      tdisabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      selectChange (key) {
        this.$emit('input', key)
        this.$emit('change', {
          key: key,
          value: this.list[key]
        })
      },
      init (list) {
        if (this.value) {
          this.selectValue = this.value
        } else {
          // this.selectValue = this.defaultAll ? this.defaultAllValue : Object.keys(list)[0]
          this.selectValue = this.defaultAll ? this.defaultAllValue : ''
        }
      }
    },
    watch: {
      selectValue (val) {
      },
      value (val) {
        this.selectValue = val
      },
      list (val) {
        this.init(val)
      }
    },
    mounted () {
      this.init(this.list)
    }
  }
</script>